import { VatPrice } from './VatPrice';
import { Package } from './Package';
import { VatPackagePriceDTO } from '../../dto';

export class VatPackagePrice {
  price: VatPrice;
  supplierItemPackage: Package;

  constructor(dto: VatPackagePriceDTO) {
    this.price = VatPrice.fromDto(dto.price);
    this.supplierItemPackage = Package.fromDto(dto.supplierItemPackage);
  }

  static fromDto(dto: VatPackagePriceDTO): VatPackagePrice {
    return new VatPackagePrice(dto);
  }
}
